import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import i18n from 'i18next';

import FlatList from './FlatList';
import { IS_FILTERING } from '../../actions/constants';

const Filter = ({ addRemoveItem, checkForEmptyList }) => {
	const MIN_FILTER_LEN = 3;
	const [filterString, setFilterString] = useState('');
	const dispatch = useDispatch();
	const isFiltering = useSelector(state => state.isFiltering);
	const allAccounts = useSelector(state => state.accounts);

	useEffect(() => {
		// Clear input if filter state changes
		if (!isFiltering && filterString.length >= MIN_FILTER_LEN) {
			setFilterString('');
		}
	}, [isFiltering]);

	const handleChange = string => {
		setFilterString(string);

		// Hide/reveal filtered list if input string is long enough
		if (isFiltering === string.length < MIN_FILTER_LEN) {
			dispatch({type: IS_FILTERING, payload: !isFiltering});
		}
	}

	const getFilteredList = () => {
		const entries = Object.entries(allAccounts);
		const items = entries.filter(x => x[1] && x[1].toLowerCase().indexOf(filterString.toLowerCase()) > -1
			|| x[0] && x[0].toLowerCase().indexOf(filterString.toLowerCase()) > -1);
		return items;
	}

	const onKeyDown = e => {
		if (e.key === 'Enter') {
			// ignore
			e.preventDefault();
			return false;
		} else if (e.key === 'Escape') {
			handleChange('');
			e.preventDefault();
			return false;
		}
	}

	const filteredList = getFilteredList();
	const filteredAcctIds = filteredList.map(x => x[0]);

	const renderList = () => {
		let component = null;

		if (isFiltering) {
			if (filteredList.length) {
				component = (<FlatList filteredList={filteredList} addRemoveItem={addRemoveItem} checkForEmptyList={checkForEmptyList} />);
			} else {
				component = (
					<div id="tree_container" className="flat-list">
						<ul>
							<li>
								<span className='node'>{i18n.t('NO_MATCHING_ACCOUNTS')}</span>
							</li>
						</ul>
					</div>
				);
			}
		}

		return component;
	}

	return (
		<div id='filter' className='mt-1'>
			<Form inline className='ml-2'>
				<FormGroup
					controlId="formBasicText"
				>
					<ControlLabel className='mr-2 ml-3'>{i18n.t('FILTER_LABEL')}</ControlLabel>
					<FormControl
						type="text"
						value={filterString}
						placeholder={i18n.t('DIST_LIST_FILTER_PLACEHOLDER')}
						onChange={e => handleChange(e.currentTarget.value)}
						onKeyDown={e => onKeyDown(e)}
					/>
					<Button
						onClick={e => handleChange('')}
						bsStyle='primary'
						className='ml-1'
					>
						{i18n.t('CLEAR')}
					</Button>
					<div hidden={!(isFiltering && filteredList.length)}>
						<Button
							bsStyle="link"
							bsSize="small"
							onClick={e => {
								e.stopPropagation();
								addRemoveItem(filteredAcctIds, true);
							}}
						>
							{i18n.t('SELECT_ALL')}
						</Button>
						<Button
							bsStyle="link"
							bsSize="small"
							onClick={e => {
								e.stopPropagation();
								checkForEmptyList(filteredAcctIds, false);
								addRemoveItem(filteredAcctIds, false);
							}}
						>
							{i18n.t('DESELECT_ALL')}
						</Button>
					</div>
				</FormGroup>
			</Form>
			{renderList()}
		</div>
	);
};

Filter.propTypes = {
	addRemoveItem: PropTypes.func,
	checkForEmptyList: PropTypes.func,
};

export default Filter;